var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
import { enPlatform, enForms } from "./labels/en-US";
import { esPlatform, esForms } from "./labels/es-US";
import { frPlatform, frForms } from "./labels/fr-CA";
import { ENGLISH, FRENCH, SPANISH } from "./languages";
import { ditto_component_library } from './ditto';
export var PLATFORM_NAMESPACE = 'Platform';
export var PLATFORM_FORMS_NAMESPACE = 'Forms';
export var PLATFORM_COMPONENT_LIBRARY = 'dittowords';
var platformResources = (_a = {},
    _a[ENGLISH] = (_b = {},
        _b[PLATFORM_NAMESPACE] = enPlatform,
        _b[PLATFORM_FORMS_NAMESPACE] = enForms,
        _b[PLATFORM_COMPONENT_LIBRARY] = ditto_component_library,
        _b),
    _a[SPANISH] = (_c = {},
        _c[PLATFORM_NAMESPACE] = esPlatform,
        _c[PLATFORM_FORMS_NAMESPACE] = esForms,
        _c),
    _a[FRENCH] = (_d = {},
        _d[PLATFORM_NAMESPACE] = frPlatform,
        _d[PLATFORM_FORMS_NAMESPACE] = frForms,
        _d),
    _a);
export var initResources = function (newResources) {
    var _a, _b, _c, _d;
    var mergedResources = (_a = {},
        _a[ENGLISH] = __assign(__assign(__assign({}, newResources[ENGLISH]), platformResources[ENGLISH]), (_b = {}, _b[PLATFORM_NAMESPACE] = __assign(__assign({}, platformResources[ENGLISH][PLATFORM_NAMESPACE]), newResources[ENGLISH][PLATFORM_NAMESPACE]), _b[PLATFORM_FORMS_NAMESPACE] = __assign(__assign({}, platformResources[ENGLISH][PLATFORM_FORMS_NAMESPACE]), newResources[ENGLISH][PLATFORM_FORMS_NAMESPACE]), _b[PLATFORM_COMPONENT_LIBRARY] = __assign(__assign({}, platformResources[ENGLISH][PLATFORM_COMPONENT_LIBRARY]), newResources[ENGLISH][PLATFORM_COMPONENT_LIBRARY]), _b)),
        _a[SPANISH] = __assign(__assign(__assign({}, newResources[SPANISH]), platformResources[SPANISH]), (_c = {}, _c[PLATFORM_NAMESPACE] = __assign(__assign({}, platformResources[SPANISH][PLATFORM_NAMESPACE]), newResources[SPANISH][PLATFORM_NAMESPACE]), _c[PLATFORM_FORMS_NAMESPACE] = __assign(__assign({}, platformResources[SPANISH][PLATFORM_FORMS_NAMESPACE]), newResources[SPANISH][PLATFORM_FORMS_NAMESPACE]), _c)),
        _a[FRENCH] = __assign(__assign(__assign({}, newResources[FRENCH]), platformResources[FRENCH]), (_d = {}, _d[PLATFORM_NAMESPACE] = __assign(__assign({}, platformResources[FRENCH][PLATFORM_NAMESPACE]), newResources[FRENCH][PLATFORM_NAMESPACE]), _d[PLATFORM_FORMS_NAMESPACE] = __assign(__assign({}, platformResources[FRENCH][PLATFORM_FORMS_NAMESPACE]), newResources[FRENCH][PLATFORM_FORMS_NAMESPACE]), _d)),
        _a);
    return mergedResources;
};
export var platformNamespaces = [PLATFORM_NAMESPACE, PLATFORM_FORMS_NAMESPACE, PLATFORM_COMPONENT_LIBRARY];
export { ENGLISH, SPANISH, FRENCH };
